import React, { FC, memo } from 'react'
import SC from '../base/Checkbox'
import { ICheckboxProps } from '../types'
import CheckIcon from '../../../icons/icon__check.svg'
import { useCheckboxCore } from '../bll'
import { Text } from '../../Text/desktop'

const { Block, Input, Label, IconWrapper } = SC

/** Чекбокс */
const Checkbox: FC<ICheckboxProps> = (props) => {
  const {
    label,
    checked,
    firstLetterUppercase,
    disabled = false,
    onChange,
    name,
    submitOnChange,
    Icon,
    fontWeight = 'medium',
    color = 'blue',
    ...otherProps
  } = props

  const { onChangeStatus } = useCheckboxCore({ name, submitOnChange, onChange })

  return (
    <Block disabled={disabled}>
      {checked && <CheckIcon />}

      <Input
        {...{ checked, ...otherProps }}
        name={name}
        onChange={onChangeStatus}
        disabled={disabled}
        color={color}
        checked={checked}
      />

      <Label firstLetterUppercase={firstLetterUppercase} disabled={disabled}>
        {typeof label === 'string' ? (
          <Text firstLetterUppercase={firstLetterUppercase} fontWeight={fontWeight} html>
            {label}
          </Text>
        ) : (
          <div>{label}</div>
        )}
      </Label>

      {Icon && (
        <IconWrapper active={checked}>
          <Icon color='blue' width='20px' height='20px' />
        </IconWrapper>
      )}
    </Block>
  )
}

export { Checkbox }
export default memo(Checkbox)
